/* src/app/feature-modules/session-engagement/components/laser-pointer/laser-pointer.component.css */
.laser-pointer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 9999;
}
.pointer {
  width: 8px;
  height: 8px;
  border-radius: 100%;
  position: fixed;
  background-color: red;
  box-shadow: 0 0 8px red;
}
/*# sourceMappingURL=laser-pointer.component.css.map */
